var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Home = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M16.4346 19.1643H3.62122V10.2507H5.29252V17.493H14.7633V10.2507H16.4346V19.1643Z" }),
    React.createElement("path", { fill: "currentColor", d: "M18.9415 9.52646L10.0279 2.1727L1.0585 9.52646L0 8.24512L10.0279 0L20 8.24512L18.9415 9.52646Z" }))); });
//# sourceMappingURL=Home.js.map